export default function ( context ) {

    return {

        homepage: {

            path: '/',
            label: context.$t( 'nav.homepage' )

        },

        dashboard: {

            path: '/user/dashboard/',
            label: context.$t( 'nav.dashboard' )

        },
        cloud: {

            path: '/user/cloud-library/',
            label: context.$t( 'nav.cloud' )

        }

    };

};



// WEBPACK FOOTER //
// ./src/config/oem/reolink-cn/router.js